// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"314":"5bc8d20d","804":"9d4b8c15"}[chunkId] + ".chunk.css";
};